
















import UserForm from "./components/UserForm.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "User",
  components: {
    UserForm,
  },
})
export default class User extends Vue {}
